import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Card, CardHeader, CardTitle } from "@shared/ui/card";
import { Activity, Package, TrendingUp } from "lucide-react";
import React from "react";

interface NetworkKeyMetricsRowProps {
  data: {
    currentCapacity: { current: number; max: number; unit: string };
    operationalPerformance: number;
    criticalAlerts: number;
    totalAssets: number;
  };
}

export const NetworkKeyMetricsRow: React.FC<NetworkKeyMetricsRowProps> = ({
  data,
}) => {
  const capacityPercentage =
    (data.currentCapacity.current / data.currentCapacity.max) * 100;

  const getPerformanceStatus = (score: number) => {
    if (score >= 80) return "Excellent";
    if (score >= 60) return "Good";
    return "Needs Attention";
  };

  const getAlertsStatus = (alerts: number) => {
    if (alerts === 0) return "All Clear";
    if (alerts <= 2) return "Monitor";
    return "Urgent";
  };

  const cards = [
    {
      title: "Current Capacity",
      displayValue: `${data.currentCapacity.current} / ${data.currentCapacity.max}`,
      count: data.currentCapacity.current,
      tooltip:
        "The current water flow (throughput) compared to the network's maximum design capacity.",
      trendSummary: `${capacityPercentage?.toFixed(1)}% utilized • ${
        data.currentCapacity.unit
      }`,
      icon: <Activity className="h-5 w-5 text-blue-600" />,
    },
    {
      title: "Operational Performance",
      displayValue: `${data.operationalPerformance}%`,
      count: data.operationalPerformance,
      tooltip:
        "A composite score representing the overall operational effectiveness of the network.",
      trendSummary: getPerformanceStatus(data.operationalPerformance),
      icon: <TrendingUp className="h-5 w-5 text-green-600" />,
    },
    // {
    //   title: "Critical Alerts",
    //   count: data.criticalAlerts,
    //   tooltip:
    //     "The number of open, high-priority alerts that require immediate attention for this network.",
    //   trendSummary: getAlertsStatus(data.criticalAlerts),
    //   icon: <AlertTriangle className="h-5 w-5 text-orange-600" />,
    // },
    {
      title: "Total Assets",
      count: data.totalAssets,
      tooltip:
        "The total number of individual assets (pipes, valves, etc.) that make up this network.",
      icon: <Package className="h-5 w-5 text-purple-600" />,
    },
  ];

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <div className="text-xs">📊</div>
          <CardTitle className="text-lg font-semibold">Key Metrics</CardTitle>
        </div>
      </CardHeader>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((card, idx) => (
          <QuickStatsCard key={idx} {...card} />
        ))}
      </div>
    </Card>
  );
};
